module.exports = __webpack_public_path__ + "media/img/home/img_birthday-party-4dd63e6e1dae6146f1ad90fa321f4495.png";